export class Filter {
  restaurantId!: number;
  kitchensId!: number[];
  pageNumber!: number;
  pageSize!: number;
  status!: OrderStatusEnum;
  searchText!: string
  orderDate?: Date
}
export enum OrderStatusEnum {
  All = 'All',
  New = 'New',
  Ongoing = 'Ongoing',
  Ready = 'Ready',
  Completed = 'Completed'
}
export class ListData {
  pageIndex!: number;
  totalCount!: number;
  pageSize!: number;
  pageData!: Order[]
  totalAll!: number
  totalNew!: number
  totalOngoing!: number
  totalReady!: number
}
export class Order {
  id!: number
  reservationId!: number
  orderKitchenId!: number
  customer!: Customer
  orderItems!: OrderItem[]
  orderNumber!: number
  orderTime!: Time
  finishedTime!: Time
  preparationTime!: string
  currentPreparationTime!: number
  PreparingTimer!: Time
  partySize!: number
  status!: OrderStatusEnum
  tabelsName!: string
  statusPermissions!: {
    canExtendTime: boolean
    canReady: boolean
    canRecall: boolean
    canStart: boolean
    canReportOrder: boolean
  }
  totalExtendedTime!: number
  extendedTime!: Time
  canRecall!: boolean
  reservationType!: string
  orderNotes!: string
  takeawayOrderType!: string
}
export class Time {
  hr!: string
  m!: string
  s!: string
  totalSeconds!: number
  isNegative?: boolean
  isWarning?: boolean
}
export class OrderItem {
  isSelected!: boolean
  statusPermissions!: {
    canCooking: boolean
    canPreparing: boolean
    canReady: boolean
  }
  canDelete!: boolean
  canEdit!: boolean
  id!: number
  itemName!: string
  itemPic!: string
  description!: string
  quantity!: number
  selectedQuantity!: number
  sizeName!: string
  itemSize!: {
    id: number
    isSelected: boolean
    name: string
  }
  isRecalled!: boolean
  recalledQuantity!: number
  isWasted!: boolean
  wastedQuantity!: number
  calories!: number
  rate!: number
  preparationTime!: { hr: string, m: string }

  kitchenId!: number
  kitchenName!: string
  menuItemId!: number
  curruncyName!: string
  price!: number
  restaurantSizeId!: number
  specialRequest!: string
  status!: OrderItemStatusEnum

  mainIngredients!: OrderIngredients[]
  optionalIngredients!: OrderIngredients[]
  unWantedOptionalIngredients!: OrderIngredients[]
  additions!: {
    id: number
    name: string
    kdsName: string
    itemAdditionlist: OrderIngredients[]
  }[]
  variants!: {
    id: number
    name: string
    kdsName: string
    itemVariantlist: OrderIngredients[]
  }[]
}
export class OrderIngredients {
  id!: number
  name!: string
  icon!: string
  isSelected!: boolean
}
export class Customer {
  icon!: string
  name!: string
}
export enum OrderItemStatusEnum {
  New = 'New',
  Preparing = 'Preparing',
  Cooking = 'Cooking',
  Ready = 'Ready',
  Served = 'Served'
}
